export const REGION_PLACE_TYPES = ['(regions)'];
